import { gql, useMutation } from '@apollo/client'
import { IChannel } from '@dtos/Channel'

export const CHANNEL_MARK_AS_READ = gql`
  mutation ChannelMarkAsRead($channelId: ID!) {
    channelMarkAsRead(
      input: { channelId: $channelId, clientMutationId: "channel-mark-as-read" }
    ) {
      channel {
        id
        unread
      }
      errors
    }
  }
`

interface IChannelMarkAsReadResult {
  channelMarkAsRead: {
    channel: IChannel | null
    errors: string[]
  }
}

export const useChannelMarkAsRead = () => {
  const [markAsRead] = useMutation<IChannelMarkAsReadResult>(
    CHANNEL_MARK_AS_READ,
    {
      refetchQueries: ['GetChannels'],
    },
  )

  const handleMarkAsRead = async (channelId: string) => {
    const response = await markAsRead({ variables: { channelId } })
    return response.data?.channelMarkAsRead
  }

  return { handleMarkAsRead }
}
